import axios from 'axios';
import Vue from 'vue'

export default {
    getInvoices (page, pageSize, customerId,status,start,end) {
        return axios.get('/api/invoices/list', { params: {page: page, pageSize: pageSize, customerId:customerId,status:status,start:start,end:end} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesCount(status){
        return axios.get('/api/invoices/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportInvoicesListExcel(page, pageSize,customerId,status,start,end){
        return axios({
            url:'/api/invoices/export/excel/list',
            params: { page: page, pageSize: pageSize,customerId:customerId, status:status, start:start,end:end},
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
                
          });
    },

    export(page, pageSize,customerId,status,start,end){
        return axios({
            url:'/api/invoices/export/excel/check',
            params: { page: page, pageSize: pageSize,customerId:customerId, status:status, start:start,end:end},
            method: 'GET',
          }).then(() => {
            return this.exportInvoicesListExcel(page, pageSize,customerId,status,start,end);
                
          }).catch(error => {Vue.prototype.$snotify.error(error);});
    },

}